import { useState } from 'react';

const testimonials = [
  {
    name: 'Carlos Mendoza',
    location: 'Bogotá, Colombia',
    type: 'presencial',
    typeLabel: 'Atención Presencial',
    typeIcon: 'ri-store-2-line',
    vehicle: 'Chevrolet Spark GT 2019',
    rating: 5,
    text: 'Llegué sin saber exactamente qué repuesto necesitaba, solo sabía que el carro hacía un ruido raro. El equipo me ayudó a identificar el problema, tenían la pieza en stock y salí con todo listo en menos de una hora. Atención increíble.',
    avatar: 'CM',
    color: 'bg-[#2563eb]',
  },
  {
    name: 'Andrés Rojas',
    location: 'Medellín → Bogotá',
    type: 'presencial',
    typeLabel: 'Atención Presencial',
    typeIcon: 'ri-store-2-line',
    vehicle: 'Suzuki Jimny 2021',
    rating: 5,
    text: 'Vine desde Medellín especialmente porque me recomendaron este lugar. Vale la pena el viaje. Encontré los repuestos que llevaba meses buscando para mi Jimny. Precios justos y garantía real. Volvería sin dudarlo.',
    avatar: 'AR',
    color: 'bg-orange-500',
  },
  {
    name: 'Patricia Gómez',
    location: 'Bogotá, Colombia',
    type: 'presencial',
    typeLabel: 'Atención Presencial',
    typeIcon: 'ri-store-2-line',
    vehicle: 'Jeep Wrangler 2020',
    rating: 5,
    text: 'Excelente atención. Me explicaron todo con paciencia, me mostraron la diferencia entre el original y el alternativo, y me dejaron decidir sin presión. El repuesto llegó perfecto y el carro quedó como nuevo.',
    avatar: 'PG',
    color: 'bg-red-500',
  },
  {
    name: 'Luis Fernández',
    location: 'Cali, Colombia',
    type: 'envio',
    typeLabel: 'Envío Nacional',
    typeIcon: 'ri-truck-line',
    vehicle: 'Chevrolet Captiva 2018',
    rating: 5,
    text: 'Desde Cali pedí el repuesto por WhatsApp, me cotizaron al instante y en 2 días lo tenía en mi casa. No tuve que viajar a Bogotá ni nada. El empaque llegó perfecto y el repuesto era exactamente lo que necesitaba.',
    avatar: 'LF',
    color: 'bg-[#2563eb]',
  },
  {
    name: 'Mónica Vargas',
    location: 'Barranquilla, Colombia',
    type: 'envio',
    typeLabel: 'Envío Nacional',
    typeIcon: 'ri-truck-line',
    vehicle: 'Suzuki Grand Vitara 2017',
    rating: 5,
    text: 'Busqué el repuesto acá en Barranquilla y nadie lo tenía. Un mecánico me recomendó este lugar en Bogotá. Me lo enviaron rapidísimo, bien empacado y con garantía. Ya les hice dos pedidos más sin problema.',
    avatar: 'MV',
    color: 'bg-yellow-500',
  },
  {
    name: 'Roberto Castillo',
    location: 'Bucaramanga, Colombia',
    type: 'envio',
    typeLabel: 'Envío Nacional',
    typeIcon: 'ri-truck-line',
    vehicle: 'RAM 1500 2019',
    rating: 5,
    text: 'Desde Bucaramanga conseguí los repuestos para mi RAM que acá son imposibles de encontrar. Todo por WhatsApp: fotos, referencia, pago y envío. Llegó en un día hábil. Muy serios y transparentes en todo el proceso.',
    avatar: 'RC',
    color: 'bg-cyan-500',
  },
];

const filters = [
  { key: 'all', label: 'Todos', icon: 'ri-star-line' },
  { key: 'presencial', label: 'Presenciales', icon: 'ri-store-2-line' },
  { key: 'envio', label: 'Envíos Nacionales', icon: 'ri-truck-line' },
];

export default function Testimonials() {
  const [active, setActive] = useState<'all' | 'presencial' | 'envio'>('all');

  const filtered = active === 'all' ? testimonials : testimonials.filter((t) => t.type === active);

  return (
    <section id="testimonios" className="bg-[#0d0d0d] py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 border border-[#2563eb]/40 text-[#2563eb] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            <i className="ri-chat-quote-line"></i>
            Testimonios
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Lo Que Dicen<br />
            <span className="text-[#2563eb]">Nuestros Clientes</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            Clientes en Bogotá y en todo el país. Atención presencial en el 7 de Agosto y envíos a cualquier ciudad de Colombia.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex justify-center mb-10 overflow-x-auto px-4 -mx-4 md:mx-0 md:px-0">
          <div className="inline-flex bg-[#1a1a1a] border border-gray-800 rounded-full p-1 gap-1 flex-shrink-0">
            {filters.map((f) => (
              <button
                key={f.key}
                onClick={() => setActive(f.key as typeof active)}
                className={`inline-flex items-center gap-2 px-4 md:px-5 py-2 rounded-full text-xs md:text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  active === f.key
                    ? 'bg-[#2563eb] text-white'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <i className={f.icon}></i>
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((t) => (
            <div
              key={t.name}
              className="bg-[#1a1a1a] border border-gray-800/60 rounded-2xl p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Type badge */}
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-400 bg-[#111] border border-gray-700 px-3 py-1 rounded-full">
                  <i className={`${t.typeIcon} text-[#2563eb]`}></i>
                  {t.typeLabel}
                </span>
                {/* Stars */}
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-sm leading-relaxed flex-1">
                <i className="ri-double-quotes-l text-[#2563eb] text-lg mr-1"></i>
                {t.text}
              </p>

              {/* Vehicle */}
              <div className="flex items-center gap-2 text-xs text-gray-500 border-t border-gray-800 pt-4">
                <i className="ri-car-line text-[#2563eb]"></i>
                {t.vehicle}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${t.color} text-white text-sm font-bold flex-shrink-0`}>
                  {t.avatar}
                </div>
                <div>
                  <div className="text-white text-sm font-semibold">{t.name}</div>
                  <div className="text-gray-500 text-xs flex items-center gap-1">
                    <i className="ri-map-pin-line"></i>
                    {t.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="mt-10 md:mt-14 bg-[#1a1a1a] border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
          <div>
            <div className="text-white font-bold text-lg mb-1">¿Estás fuera de Bogotá?</div>
            <p className="text-gray-400 text-sm">Enviamos a cualquier ciudad de Colombia. Cotiza por WhatsApp y te explicamos el proceso paso a paso.</p>
          </div>
          <a
            href="https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-bold px-8 py-3.5 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Consultar Envío Nacional
          </a>
        </div>
      </div>
    </section>
  );
}
